"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/response-file.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Fresponse-file.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordEntriesEntry = exports.Record = exports.ExperianResponseFile = exports.TransUnionResponseFile = exports.ResponseFile = void 0;
const protobufPackage = 'com.step.creditreport.proto';
function createBaseResponseFile() {
    return { hasError: false, transunion: undefined, experian: undefined };
}
exports.ResponseFile = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.hasError)) {
            message.hasError = globalThis.Boolean(object.hasError);
        }
        if (isSet(object.transunion)) {
            message.transunion = exports.TransUnionResponseFile.fromJSON(object.transunion);
        }
        if (isSet(object.experian)) {
            message.experian = exports.ExperianResponseFile.fromJSON(object.experian);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hasError !== undefined && message.hasError !== false) {
            obj.hasError = message.hasError;
        }
        if (message.transunion !== undefined) {
            obj.transunion = exports.TransUnionResponseFile.toJSON(message.transunion);
        }
        if (message.experian !== undefined) {
            obj.experian = exports.ExperianResponseFile.toJSON(message.experian);
        }
        return obj;
    },
    create(base) {
        return exports.ResponseFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResponseFile();
        message.hasError = object.hasError ?? false;
        message.transunion = (object.transunion !== undefined && object.transunion !== null)
            ? exports.TransUnionResponseFile.fromPartial(object.transunion)
            : undefined;
        message.experian = (object.experian !== undefined && object.experian !== null)
            ? exports.ExperianResponseFile.fromPartial(object.experian)
            : undefined;
        return message;
    },
};
function createBaseTransUnionResponseFile() {
    return { records: [] };
}
exports.TransUnionResponseFile = {
    fromJSON(object) {
        const message = {
            records: globalThis.Array.isArray(object?.records)
                ? object.records.map((e) => exports.Record.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.records?.length) {
            obj.records = message.records.map((e) => exports.Record.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionResponseFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionResponseFile();
        message.records = object.records?.map((e) => exports.Record.fromPartial(e)) || [];
        return message;
    },
};
function createBaseExperianResponseFile() {
    return { records: [] };
}
exports.ExperianResponseFile = {
    fromJSON(object) {
        const message = {
            records: globalThis.Array.isArray(object?.records)
                ? object.records.map((e) => exports.Record.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.records?.length) {
            obj.records = message.records.map((e) => exports.Record.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ExperianResponseFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExperianResponseFile();
        message.records = object.records?.map((e) => exports.Record.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRecord() {
    return { entries: {} };
}
exports.Record = {
    fromJSON(object) {
        const message = {
            entries: isObject(object.entries)
                ? Object.entries(object.entries).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            const entries = Object.entries(message.entries);
            if (entries.length > 0) {
                obj.entries = {};
                entries.forEach(([k, v]) => {
                    obj.entries[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.Record.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecord();
        message.entries = Object.entries(object.entries ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseRecordEntriesEntry() {
    return { key: '', value: '' };
}
exports.RecordEntriesEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.RecordEntriesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordEntriesEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=response-file.js.map